import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import { RiArrowGoBackFill } from "react-icons/ri";
import { AiOutlineClose } from "react-icons/ai";

import { DetailInfoContaienr } from "../../mypage/scheduler/component/styled/scheduler";

const Info = ({ setActive, active, navigatePath }) => {
  const navigate = useNavigate();

  const user = useSelector((state) => state?.user?.data[0]);
  const handleButtonClick = () => {
    active !== 1 ? setActive(1) : navigate("/");
  };

  return (
    <DetailInfoContaienr>
      <button onClick={handleButtonClick}>
        {active !== 1 ? <RiArrowGoBackFill /> : <AiOutlineClose />}
      </button>
      <span>리포트</span>
    </DetailInfoContaienr>
  );
};

export default Info;
